<template lang="pug">
  .preview._fixed._overlay._bg-white._text-black._flex._items-center._justify-center Loading Preview...
</template>

<script>
export default {
  name: 'Preview',
  beforeCreate () {
    const previewToken = this.$route.query.token
    // todo update to getPreviewResolver
    this.$prismic.client.previewSession(previewToken, this.$prismic.linkResolver, '/')
      .then((url) => {
        // window.location.replace(url)
        this.$router.replace(url)
      })
  }
}
</script>
